module.exports = __webpack_public_path__ + "static/media/printer.3a8e72ca.svg";